const reportes_routes = [
  {
    path: "/reportes/agencia",
    name: "reportes.agencia",
    component: () => import(/* webpackChunkName: "reportes-agencia" */ "@/modules/reportes/views/ReporteAgencia.vue"),
  },
  {
    path: "/reportes/endoses-fecha",
    name: "reportes.endoses-fecha",
    component: () => import(/* webpackChunkName: "reportes-endoses-fecha" */ "@/modules/reportes/views/ReporteEndosesPorFecha.vue"),
  },
  {
    path: "/reportes/movilidad",
    name: "reportes.movilidad",
    component: () => import(/* webpackChunkName: "reportes-movilidad" */ "@/modules/reportes/views/Movilidad.vue"),
  },
  {
    path: "/reportes/liquidaciones",
    name: "reportes.liquidaciones",
    component: () => import(/* webpackChunkName: "reportes-liquidaciones" */ "@/modules/reportes/views/Liquidaciones.vue"),
  },
];

export default reportes_routes;
